export default __webpack_public_path__ + "static/media/Paikang.970db38a.jpg";